import useTranslation from 'hooks/useTranslation'
import PaymentSchedule from './PaymentSchedule'
import PaymentHistory from './PaymentHistory'
import { useParams } from 'react-router-dom'
import PayExtra from 'containers/PayExtra'
import PaymentCard from './PaymentCard'
import React from 'react'

const Payments: React.FC = () => {
  const params = useParams<{ action?: string }>()
  const { t } = useTranslation('account')

  if (params?.action === 'extra') {
    return <PayExtra isPopup />
  }

  return (
    <div className='account__payments summary'>
      <div className='account__header title'>
        <div>{t('payments')}</div>
        <div>{t('subTitle')}</div>
      </div>

      {/* Zakomentowane póki nie ogarniemy */}
      <PaymentCard />
      <PaymentSchedule />
      <PaymentHistory />
    </div>
  )
}

export default Payments